import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from './Button'

export const IconButton = ({ icon, children, ...props }) => { 
  return (
    <Button className="icon-button button primary" {...props}>
      {children}
      <FontAwesomeIcon icon={icon} />
    </Button>
  )
}
